import cx from 'clsx';
import React from 'react';
import { IClose } from './Icons.tsx';

export type AutocompleteSuggestion = {
  key: string;
  label: string;
};

type Props = {
  suggestions: AutocompleteSuggestion[];
  label: string;
  placeholder: string;
  value: string;
  onValueChange: (newValue: string) => void;
  loading?: boolean;
};

export const Autocomplete: React.FC<Props> = ({ suggestions, label, placeholder, value, onValueChange, loading }) => {
  const [selectedLabel, setSelectedLabel] = React.useState('');
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!value) setSelectedLabel('');
  }, [value]);

  const isSelected = !!selectedLabel;

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium">{label}</label>

      {isSelected ? (
        <div className="input flex items-center justify-between">
          <span className="text-sm">{selectedLabel}</span>
          <button
            type="button"
            className="ml-2 flex items-center text-gray-400 hover:text-gray-600"
            onClick={() => { setSelectedLabel(''); onValueChange(''); }}
          >
            <IClose size={14} />
          </button>
        </div>
      ) : (
        <div className="relative">
          <input
            type="text"
            className="input w-full"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            onFocus={() => setOpen(true)}
            onBlur={() => setTimeout(() => setOpen(false), 150)}
            autoComplete="off"
          />
          {open && (loading || suggestions.length > 0) && (
            <ul className="absolute z-10 mt-1 w-full rounded border border-gray-200 bg-white shadow-md max-h-48 overflow-y-auto">
              {loading && <li className="px-3 py-2 text-sm text-gray-400">...</li>}
              {suggestions.map((s) => (
                <li
                  key={s.key}
                  className={cx('cursor-pointer px-3 py-2 text-sm hover:bg-gray-100')}
                  onMouseDown={() => {
                    setSelectedLabel(s.label);
                    onValueChange(s.key);
                    setOpen(false);
                  }}
                >
                  {s.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
